type FindIndexBinaryProps<T> = {
    array: T[]
    isGuessMatchingTarget: (guess: T) => boolean
    isGuessBelowTarget: (guess: T) => boolean
}

export const findIndexBinary = <T>(props: FindIndexBinaryProps<T>): number => {
    const { array, isGuessMatchingTarget, isGuessBelowTarget } = props
    let lowIndex = 0
    let highIndex = array.length - 1

    while (lowIndex <= highIndex) {
        const midIndex = Math.floor((lowIndex + highIndex) / 2)
        const guess = array[midIndex]

        if (isGuessMatchingTarget(guess)) {
            return midIndex
        } else if (isGuessBelowTarget(guess)) {
            lowIndex = midIndex + 1
        } else {
            highIndex = midIndex - 1
        }
    }

    return -1
}
